<template>
  <section>
    <fixed-header :title="pageTitle" />
    <b-card class="h-100" body-class="margin-top-fixed-header" v-if="showReport">
      <div class="d-flex justify-content-start align-items-end mb-2" v-if="showFilters">
        <div v-for="(filter,i) in filters" :key="i">
        
          <b-form-group v-if="filter.type == 'dateRange'" class="required">
            <date-range-picker :label="filterObj[filter.label]" @handleSearch="handleDate"></date-range-picker>
          </b-form-group>

          <b-form-group v-if="filter.type == 'text'" class="mr-2" :label="filter.label">
            <b-form-input size="sm" v-model="filterObj[filter.prop]" />
          </b-form-group>

          <b-form-group v-if="filter.type == 'suggestText'" class="mr-2" :label="filter.label">
            <vue-simple-suggest
              id="suggest-company"
              class="suggest-input form-control "
              :styles="autoCompleteStyle"
              :list="getListOfNames"
              :max-suggestions="20"
              :min-length="3"
              :debounce="200"
              v-model="chosenName"
              :filter-by-query="true"
              value-attribute="id"
              display-attribute="name"
              @select="onSuggestNameSelect"
              @input="onSuggestNameChange"
              @blur="onCompanyBlur"
              @request-done="onRequestDone"
              autocomplete="off"
              style="width: 200px;"
             />
            <div slot="misc-item-below" v-if="isLoading" class="misc-item">
              <span>Loading...</span>
            </div>
          </b-form-group>

          <b-form-group v-if="filter.type == 'dropdown'" class="mr-2" :label="filter.label">
            <b-form-select v-model="filterObj[filter.prop]">
              <option v-for="(select, i) in filter.options" :key="i" :value="select.value"
              >{{ select.name }}</option>
            </b-form-select>
          </b-form-group>

          <b-form-group v-if="filter.type == 'salesRepDropdown'" class="mr-2" :label="filter.label">
            <b-form-select v-model="filterObj[filter.prop]">
              <option :value="null">All</option>
              <option :value="'unassigned'">Unassigned</option>
              <option
                v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                :key="indexRep"
                :value="selectRep.id"
              >{{ selectRep.name }}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="run-report-button-container" v-if="filters.length > 0">
          <b-button size="sm" variant="primary" class="mr-2" @click="onSearch" :disabled="isRunning || isDisabledTriggerBtn">
            <span v-if="isRunning" class="fa fa-spinner fa-pulse fa-fw mr-1"></span>
            Run Report
          </b-button>
          <b-button v-if="!isExportNA" size="sm" variant="warning" @click="onExport" :disabled="isExporting || isDisabledExport">
            <span v-if="isExporting" class="fa fa-spinner fa-pulse fa-fw mr-1"></span>
            Export to Excel
          </b-button>
        </div>
      </div>
      
      
      <br/>
      <b-row>
        <b-col v-if="isFastReportResults">
          <iframe height="700" width="1200" :src="generateReport"></iframe>
        </b-col>
        <b-col v-else-if="isGroupedResult">
          <vue-good-table
            compactMode
            fixedHeader
            ref="GroupedTable"
            :isLoading="isRunning"
            :columns="reportFields"
            :rows="reportResult"
            :group-options="{
              enabled: true,
              collapsable: true
            }"
            styleClass="vgt-table condensed"
          >  
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.cell == 'formatDate'">
                 {{ date(props.row[props.column.field]) }}
              </span>
              <span v-else-if="props.column.cell == 'formatMoney'">
                ${{ commafy(props.row[props.column.field]) }}
              </span>
              <span v-else>
                {{ props.row[props.column.field] }}
              </span>
            </template>

          </vue-good-table>
        </b-col>
        <b-col v-else>
          <vue-good-table
            compactMode
            fixedHeader
            ref="SimpleTable"
            :isLoading="isRunning"
            :columns="reportFields"
            :rows="reportResult"
            styleClass="vgt-table condensed vgt-table fixed-header"
          >  
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.cell == 'formatDate'">
                 {{ date(props.row[props.column.field]) }}
              </span>
              <span v-else-if="props.column.cell == 'formatMoney'">
                {{ commafy(props.row[props.column.field]) }}
              </span>
              <span v-else>
                {{ props.row[props.column.field] }}
              </span>
            </template>

          </vue-good-table>
        </b-col>
      </b-row>
      
    </b-card>
  </section>
</template>

<script>
import FixedHeader from '@/shared/components/FixedHeader';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
import GridComponent from '@/shared/components/GridComponent';
import VueSimpleSuggest from 'vue-simple-suggest';
import { mapActions, mapState } from 'vuex';
import { reportTitles, reportFilters } from './config';
import { 
  AR_SUMMARY_FIELDS, AR_DETAILS_FIELDS,
  AP_SUMMARY_FIELDS, AP_DETAILS_FIELDS,
  INC_CUST_SUMMARY_FIELDS, INC_CUST_DETAILS_FIELDS,
  EXP_VEND_SUMMARY_FIELDS, EXP_VEND_DETAILS_FIELDS,
  CREDIT_MEMO_SUMMARY_FIELDS, CREDIT_MEMO_DETAILS_FIELDS,
  INVENTORY_WORKSHEET_FIELDS, EMPLOYEE_SALES_COMMISSION_DETAILS_FIELDS
} from './fields';
import { AUTO_COMPLETE_STYLES } from '@/shared/constants';
import { date } from '@/shared/filters';
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';

export default {
  components: {
      FixedHeader,
      DateRangePicker,
      GridComponent,
      VueGoodTable,
      VueSimpleSuggest
  },
  data() {
    return {
      date,
      reportTitles,
      reportFilters,
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      AR_SUMMARY_FIELDS,
      AR_DETAILS_FIELDS,
      AP_SUMMARY_FIELDS,
      AP_DETAILS_FIELDS,
      INC_CUST_SUMMARY_FIELDS,
      INC_CUST_DETAILS_FIELDS,
      EXP_VEND_SUMMARY_FIELDS, 
      EXP_VEND_DETAILS_FIELDS,
      CREDIT_MEMO_SUMMARY_FIELDS,
      CREDIT_MEMO_DETAILS_FIELDS,
      INVENTORY_WORKSHEET_FIELDS,
      EMPLOYEE_SALES_COMMISSION_DETAILS_FIELDS,
      reportFields: [],
      pageTitle: 'Report: ',
      filterObj: {},
      currentToken: null,
      showReport: false,
      showFilters: false,
      isRunning: false,
      isGroupedResult: false,
      reportResult: [],
      filters: [],
      isExporting: false,
      isExportNA: false,
      fastReportFileName: null,
      generateReport: null,
      isFastReportResults: false,
      chosenName: '',
      isLoading: false,
      namesList: []
    }
  },
  computed: {
    ...mapState('salesReps', ['salesReps']),
    isDisabledTriggerBtn() {
      if (this.showFilters && this.filters.findIndex(x => x.type == 'dateRange') > -1) {
        return this.filterObj.from == null && this.filterObj.to == null;
      }
      return false;
    },
    isDisabledExport() {
      return this.reportResult.length == 0;
    }
  },
  methods: {
    ...mapActions('reports', ['queryReport', 'exportReport']),
    ...mapActions('companies', ['getByNameAndAccountType']),
    handleDate(dateVal) {
      this.filterObj = {
        ...this.filterObj,
        from: dateVal.dateFrom,
        to: dateVal.dateTo
      }
    },
    onSearch() {        
      if (!this.isFastReportResults) {
        let formData = JSON.stringify({
          ...this.filterObj,
          token: this.currentToken
        });
        this.isRunning = true;
        this.queryReport(formData).then((res) => {
          this.isRunning = false;
          if (res) 
            this.reportResult = res;
            // this.showReport = true;
            // this.$refs.GroupedTable.expandAll();
        });  
      } else {
        this.onGenerateFastReport();
      }
      
    },
    onExport() {
      this.isExporting = true;
      let formData = JSON.stringify({
        ...this.filterObj,
        token: this.currentToken,
        columnsForExport: this.reportFields.map(x => x.label).join(',')
      });
      this.exportReport(formData).then((res) => {
        this.isExporting = false;
      });
    },
    onGenerateFastReport() {
      // let url = `DateBeg=${this.filterObj.from}&DateEnd=${this.filterObj.to}&SalesRep=${this.filterObj.salesRep}&FindCompany=${this.filterObj.companyName}&ReportFile=${this.fastReportFileName}`;
      let url = `ReportFile=${this.fastReportFileName}`
      this.generateReport = null;
      
      for (let i = 0; i < Object.keys(this.filterObj).length; i++) {
        let key = Object.keys(this.filterObj)[i];
        url += `&${key}=${this.filterObj[key]}`;
      }

      this.generateReport = process.env.VUE_APP_API_URL + 'GenerateFastReport?' + url;
    },
    commafy(num, decimal = 2) {
      try {
        if (num != null) {
          var str = num.toString().split('.');
          if (str[0].length >= 3) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
          }
          if (str[1]) {
            if (str[1].length < decimal) {
              while (str[1].length < decimal) { str[1] = str[1] + "0"; }
            } else if (str[1].length > decimal) {
              str[1] = str[1].substring(0, decimal)
            }
          }
          return str.join('.');
        }
      } catch {
        return num;
      }
    },
    async getListOfNames(name) {
      this.namesList = await this.getByNameAndAccountType({typeId: 0, name});
      return this.namesList;
    },
    async onSuggestNameSelect(suggestion) {
      this.filterObj.company = suggestion.id;
    },
    async onSuggestNameChange(prop) {
      // this.isLoading = true;
      // console.log(this.chosenName, 'Chosen name');
      // if (this.filterObj[prop] && this.filterObj[prop] != this.chosenName) {
      //   this.filterObj[prop] = null;
      // }
    },
    async onCompanyBlur(prop) {
      
      if(this.chosenName) {
        if (this.namesList.length > 0) {
          const findIndex = this.namesList.findIndex(x => this.chosenName.toLowerCase() == x.name.toLowerCase());
          console.log('on blurred', findIndex)
          if (findIndex > -1) {
            this.onSuggestNameSelect(this.namesList[findIndex]);
          }
        }
      }
    },
    onRequestDone() {
      this.isLoading = false;
    },
  },
  mounted() {
    if (this.$route.query.token && this.reportTitles[this.$route.query.token]) {
      this.currentToken = this.$route.query.token;
      this.reportFields = this[this.$route.query.token + "_FIELDS"];
      
      let reportConfig = this.reportTitles[this.$route.query.token];

      if (reportConfig) {        
        this.pageTitle += reportConfig.name || '';
        this.isGroupedResult = reportConfig.isGroupResult || false;
        this.filters = this.reportFilters[reportConfig.filterRef] || [];
        this.showReport = true;
        this.isExportNA = reportConfig.isExportNA;
        this.fastReportFileName = reportConfig.reportFileName;
        this.isFastReportResults = reportConfig.isFastReportResult;
        // Initialize the filter objects...
        if (this.filters.length > 0) {
          let props = this.filters.map((key) => key.prop);
          this.filterObj = props.filter(i => i != '').reduce((prop, curr) => (prop[curr]=null, prop), {});
          if (this.filters.findIndex(x => x.type == 'dateRange') > -1) {
            this.filterObj = {
              ...this.filterObj,
              from: null,
              to: null
            }
          }
          this.showFilters = true;
        }   
      }

     
      
    }
  }
}

</script>
<style>
.run-report-button-container {
  margin-top: 12px;
  text-align: right;
}
</style>
